<p-toast life="5000" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <p style="text-align: center; font-weight: bold;">{{message.summary}}</p>
        <p innerHtml="{{message.detail}}"></p>
    </ng-template>
</p-toast>
